import "./intro.css";

import pic from "../../img/pic.jpg";

const Intro = () => {
  return (
    <div className="i" id="intro">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Hello, My name is</h2>
          <h1 className="i-name">Sameel Paikadan</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Front End Developer</div>
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Front End Developer</div>
            </div>
          </div>
          <p className="i-desc">
            A passionate programmer with a curious mind who loves solving problems.
            I have an experience of building Web applications with JavaScript / Reactjs / HTML / CSS etc.
            I'm currently actively looking for new opportunities
          </p>
        </div>
        
      </div>
      <div className="i-right">
         <div className="a-left">
        {/* <div className="a-card bg"></div> */}
       <div className="a-card">
          <img
            src={pic}
            alt=""
            className="a-img"
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default Intro;
